
export enum ShipperCreditStatusCd {
	BANKRUPT = 'Bankrupt',
	CASH = 'Cash',
	CREDIT = 'Credit',
	NO_CREDIT = 'No Credit',
	VOLUNTARY = 'Voluntary'}

